import { render, staticRenderFns } from "./ProductGroups.vue?vue&type=template&id=42eb6cb2&scoped=true&"
import script from "./ProductGroups.vue?vue&type=script&lang=js&"
export * from "./ProductGroups.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroups.vue?vue&type=style&index=0&id=42eb6cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eb6cb2",
  null
  
)

export default component.exports